import { render, staticRenderFns } from "./CardTestimonial.vue?vue&type=template&id=13f1021f&scoped=true"
import script from "./CardTestimonial.vue?vue&type=script&lang=js"
export * from "./CardTestimonial.vue?vue&type=script&lang=js"
import style0 from "./CardTestimonial.vue?vue&type=style&index=0&id=13f1021f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f1021f",
  null
  
)

export default component.exports